export const stateMicrosites = {
  hasInsertedFavicon: { value: false },
  hasInsertedGoogleTagmanager: { value: false },
};